import { useNavigate } from "react-router-dom";
import {
	type FinancesNavigationState,
	FinancesOrigin,
} from "web_myplann/Finances/Types/FinancesNavigationState";
import { useLocationState } from "web_myplann/Shared/Hooks/useLocationState";

export const useFinancesWizardNavigation = () => {
	const navigate = useNavigate();
	const navigationState = useLocationState<FinancesNavigationState>();

	const isFromProfile = navigationState.from === FinancesOrigin.Profile;

	const goToStep = (
		path: string,
		state: FinancesNavigationState = navigationState,
	) => {
		navigate(path, { replace: true, state });
	};

	return { navigationState, isFromProfile, goToStep };
};
